module.exports = __webpack_public_path__ + "media/input3.d1556dc4.wav";